// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.intro-interests-module__container____x0Af {
  text-align: center;
}

.intro-interests-module__title___O1M0T {
  font-weight: 500;
  font-size: 1.5rem;
  color: var(--neutral100, #2c2e30);
  margin-bottom: 32px;
  margin-top: 12px;
}

.intro-interests-module__subtitle___jVLgC {
  font-size: 1.125rem;
  color: var(--neutral75, #424547);
}

.intro-interests-module__info___xzAEZ {
  font-size: 1rem;
  color: var(--neutral75, #424547);
  margin-top: 24px;
}

.intro-interests-module__img-container___XCDD9 {
  max-width: 250px;
  margin: 0 auto;
}
.intro-interests-module__img-container___XCDD9 img {
  width: 100%;
  height: auto;
}

.intro-interests-module__button-container___Ure8i {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
}
.intro-interests-module__button-container___Ure8i button {
  width: -moz-fit-content;
  width: fit-content;
  font-size: 1rem;
}`, "",{"version":3,"sources":["data:;charset=utf-8,/**%20function%20to%20get%20dimensions%0A%20%20usage%20example%20to%20get%20%60tablet%60%20value%20from%20%60$page-max-widths%60%0A%20%20.class%20%7B%0A%20%20%20%20max-width:%20dim($page-max-widths,%20tablet);%0A%20%20%7D%0A%0A%20*/%0A%0A@use%20'sass:map';%0A%0A@function%20dim($prop,%20$key)%20%7B%0A%20%20@return%20map.get($prop,%20$key);%0A%7D%0A","webpack://./client/app/pages/home/components/your-interests/select-interests/intro-interests/intro-interests.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,kBAAA;AAMF;;AAHA;EACE,gBAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;EACA,gBAAA;AAMF;;AAHA;EACE,mBAAA;EACA,gCAAA;AAMF;;AAHA;EACE,eAAA;EACA,gCAAA;EACA,gBAAA;AAMF;;AAHA;EACE,gBAAA;EACA,cAAA;AAMF;AAJE;EACE,WAAA;EACA,YAAA;AAMJ;;AAFA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAKF;AAHE;EACE,uBAAA;EAAA,kBAAA;EACA,eAAA;AAKJ","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `intro-interests-module__container____x0Af`,
	"title": `intro-interests-module__title___O1M0T`,
	"subtitle": `intro-interests-module__subtitle___jVLgC`,
	"info": `intro-interests-module__info___xzAEZ`,
	"img-container": `intro-interests-module__img-container___XCDD9`,
	"button-container": `intro-interests-module__button-container___Ure8i`
};
export default ___CSS_LOADER_EXPORT___;
